import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EncounterPhase, EncounterType } from 'src/models';
import { ambientApi } from 'src/services';

export interface UseCreateSummaryVersionPayload {
  encounterId: string;
  encounterPhase: EncounterPhase;
  type?: EncounterType;
  summaryJson: string;
  version: number;
}

export const useCreateSummaryVersion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['createSummaryVersion'],
    mutationFn: (payload: UseCreateSummaryVersionPayload) => {
      return ambientApi.put(
        `/summaries/version`,
        {
          summary_json: payload.summaryJson,
          version: payload.version,
        },
        {
          params: {
            encounter_id: payload.encounterId,
            encounter_phase: payload.encounterPhase,
            type: payload.type,
          },
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['summaryList'],
      });
    },
  });
};
